"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachTo = attachTo;
exports.attach = exports.attachEmitter = void 0;

var _qbus = _interopRequireDefault(require("./qbus"));

function hide(target, property, value) {
  var configurable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  Object.defineProperty(target, property, {
    value: value,
    configurable: !!configurable,
    enumerable: false
  });
  return target;
}

function attachTo(host) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var emitter = new _qbus["default"]();
  var _options$configurable = options.configurable,
      configurable = _options$configurable === void 0 ? true : _options$configurable;
  hide(host, 'emitter', emitter, configurable);
  hide(host, 'on', emitter.on.bind(emitter), configurable);
  hide(host, 'addListener', emitter.on.bind(emitter), configurable);
  hide(host, 'once', emitter.once.bind(emitter), configurable);
  hide(host, 'off', emitter.off.bind(emitter), configurable);
  hide(host, 'removeAllListeners', emitter.off.bind(emitter), configurable);
  hide(host, 'emit', emitter.emit.bind(emitter), configurable);
  hide(host, 'trigger', emitter.emit.bind(emitter), configurable);
  return emitter;
}

var attachEmitter = attachTo;
exports.attachEmitter = attachEmitter;
var attach = attachTo;
exports.attach = attach;